import React, { useState } from "react";
import { Button, Input, Popup } from "semantic-ui-react";
import { useDispatch } from "react-redux";
import { addPosition } from "../../store/actions/athleteActions";
import { AiOutlinePlus } from "react-icons/ai";
import { GrClose } from "react-icons/gr";
import { BsFillPatchCheckFill } from "react-icons/bs";
import "./AddNew.css";
import SportList from "../athletes/SportList";
const AddNewPosition = props => {
  const [position, setPosition] = useState(null);
  const [addedPosition, setAddedPosition] = useState(false);
  const [numbers, setNumbers] = useState(null);
  const [sport, setSport] = useState(null);
  const dispatch = useDispatch();
  const stringContainsNumber = _string => /\d/.test(_string);
  const executeState = () => setAddedPosition(true);

  const newPositionAddHandler = e => {
    e.preventDefault();

    if (!position) {
    } else {
      const myPromise = new Promise((resolve, reject) => {
        dispatch(addPosition(position, sport));
      });
      myPromise
        .then(setTimeout(executeState(), 6500))
        .then(setTimeout(props.onClose, 500));
    }
  };
  const handleSportChange = (e, data) => {
    setSport(data.value);
  };
  const fetchInputValue = e => {
    setNumbers(null);
    const checker = e.target.value.trim();
    if (stringContainsNumber(checker)) {
      setNumbers(true);
    }
    setPosition(checker);
  };
  return (
    <>
      <div className="main-card">
        <div className="header-data">
          <label>Add New Position</label>
          <GrClose size="15" onClick={props.onClose} />
        </div>
        <div className="cu-input">
          <SportList
            onChange={handleSportChange}
            name="sportDropdown"
            placeholder="Football"
            clearable
          />
        </div>
        <div className="cu-input mt2">
          <Input
            placeholder="Left Back"
            id="newSportName"
            onChange={fetchInputValue}
          />
        </div>
        {position && numbers && <p>Numbers Are Not Allowed</p>}
        {position && !numbers && sport && (
          <Button
            positive
            name="okButton"
            content="Submit"
            onClick={newPositionAddHandler}
          />
        )}
        {!position && !sport && (
          <Button disabled name="disabledButton" content="Submit" />
        )}
        {position && !sport && (
          <Button disabled name="disabledButton" content="Submit" />
        )}
        {!position && sport && (
          <Button disabled name="disabledButton" content="Submit" />
        )}
        {numbers && <Button disabled name="disabledButton" content="Submit" />}
        {addedPosition && (
          <span className="success">
            Added <BsFillPatchCheckFill size={16} />
          </span>
        )}
      </div>
    </>
  );
};
export const AddNewPositionIcon = props => {
  return (
    <span className="AdminQuestionIconContainer">
      <span className="AdminQuestionIconContainer">
        <Popup
          content="Add New Position"
          trigger={
            <AiOutlinePlus
              name="Add New Position"
              onClick={props.onClick}
              className="plusIcon"
              cursor="pointer"
            />
          }
        />
      </span>
    </span>
  );
};
export default AddNewPosition;